import { Injectable } from '@angular/core';
import { FndyObjectService } from '@thinglogix/ngx-foundry-core';
import { Observable, of } from 'rxjs';
import {
    debounceTime,
    distinctUntilChanged,
    finalize,
    map,
    switchMap,
    tap,
} from 'rxjs/operators';
import { SearchApiService } from 'src/app/services/search-api.service';
import { AttributeFormatPipe } from 'src/app/shared/attribute-format.pipe';
import { SkuModel } from 'src/app/_models/sku.model';
import { SkusQuery } from './skus.query';
import { SkusStore } from './skus.store';
const DEBOUNCE_TIME_MS = 200;
const numberSlice = 100;
@Injectable({
    providedIn: 'root',
})
export class SkusService {
    constructor(
        protected store: SkusStore,
        protected query: SkusQuery,
        private searchApiService: SearchApiService,
        private objectService: FndyObjectService,
        private attributeFormat: AttributeFormatPipe
    ) {}

    clearDetail(): void {
        this.store.update(() => ({
            detail: null,
        }));
    }

    clearError(): void {
        this.store.setError(null);
    }

    initSearch(): Observable<SkuModel[]> {
        return this.query
            .select((state) => state.ui.searchInput)
            .pipe(
                distinctUntilChanged(),

                debounceTime(DEBOUNCE_TIME_MS),
                switchMap((filter) => {
                    this.store.setLoading(true);
                    if (!filter) {
                        return of([]);
                    }
                    return this.searchApiService
                        .getObjectsByName(
                            filter.trim(),
                            '2699fec0-7ef0-11ec-97bf-cfcb819cf8b0',
                            'a.name'
                        )
                        .pipe(map((objects) => objects.slice(0, numberSlice)));
                }),
                map((objects) =>
                    objects.map((object) =>
                        this.attributeFormat.transform<SkuModel>(object)
                    )
                ),
                tap((objects) => {
                    this.store.set(objects);
                }),
                finalize(() => {
                    this.store.setLoading(false);
                })
            );
    }

    getAllSkus(): Observable<SkuModel[]> {
        this.store.setLoading(true);
        return this.objectService
            .getObjectsByType('2699fec0-7ef0-11ec-97bf-cfcb819cf8b0')
            .pipe(
                map((objects) =>
                    objects.map(
                        (object) =>
                            this.attributeFormat.transform<SkuModel>(object),
                        console.log(
                            '0e1d22f0-7a22-11ec-bb91-cdba4dbd7b2d',
                            objects
                        )
                    )
                ),
                tap((objects) => {
                    console.log(objects);
                    this.store.set(objects);
                    console.log(objects);
                }),
                finalize(() => {
                    this.store.setLoading(false);
                })
            );
    }

    getSkuDetail(id: string): void {
        this.store.setLoading(true);
        this.objectService
            .getObject(id)
            .pipe(
                map((object) =>
                    this.attributeFormat.transform<SkuModel>(object)
                ),
                finalize(() => {
                    this.store.setLoading(false);
                })
            )
            .subscribe((sku) => {
                this.store.update({ detail: sku });
            });
    }

    updateSearchInput(searchInput: any): void {
        this.store.update((state) => ({
            ...state,
            ui: {
                ...state.ui,
                searchInput,
            },
        }));
    }

    updateItemsPerPage(itemsPerPage: number): void {
        this.store.update((state: { ui: any }) => ({
            ui: {
                ...state.ui,
                itemsPerPage,
            },
        }));
    }

    updateCurrentPage(currentPage: number): void {
        this.store.update((state) => ({
            ui: {
                ...state.ui,
                currentPage,
            },
        }));
    }
}
